import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Sidebar Layouts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Two-Column Layout</label>
            <div className="flex gap-2 h-32 bg-slate-950 rounded border border-slate-600">
              <div className="w-24 bg-slate-800 border-r border-slate-700 p-2 text-xs text-slate-400">Sidebar</div>
              <div className="flex-1 p-2 text-xs text-slate-400">Main Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-2">\n  <div className="w-24 bg-slate-800 border-r p-2">Sidebar</div>\n  <div className="flex-1 p-2">Main</div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Collapsed Sidebar</label>
            <div className="flex gap-2 h-32 bg-slate-950 rounded border border-slate-600">
              <div className="w-12 bg-slate-800 border-r border-slate-700 p-2 text-xs text-slate-500">=</div>
              <div className="flex-1 p-2 text-xs text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-2">\n  <div className="w-12 bg-slate-800 border-r p-2">=</div>\n  <div className="flex-1 p-2">Content</div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Navigation Items</label>
            <div className="flex gap-2 h-32 bg-slate-950 rounded border border-slate-600">
              <div className="w-28 bg-slate-800 border-r border-slate-700 p-2 text-xs space-y-1">
                <div className="bg-slate-700 p-1 rounded text-slate-300">Dashboard</div>
                <div className="bg-slate-800 p-1 rounded text-slate-500">Settings</div>
              </div>
              <div className="flex-1 p-2 text-xs text-slate-400">Page</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-28 bg-slate-800 p-2 space-y-1">\n  <div className="bg-slate-700 p-1 rounded">Dashboard</div>\n  <div className="bg-slate-800 p-1">Settings</div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Three-Column Layout</label>
            <div className="flex gap-2 h-32 bg-slate-950 rounded border border-slate-600">
              <div className="w-20 bg-slate-800 border-r border-slate-700 p-2 text-xs text-slate-400">Left</div>
              <div className="flex-1 bg-slate-850 border-r border-slate-700 p-2 text-xs text-slate-400">Center</div>
              <div className="w-20 bg-slate-800 p-2 text-xs text-slate-400">Right</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-2">\n  <div className="w-20 bg-slate-800">Left</div>\n  <div className="flex-1">Center</div>\n  <div className="w-20 bg-slate-800">Right</div>\n</div>`} />
          </div>
        </div>
      </div>

      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Layouts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Floating Sidebar</label>
            <div className="relative h-32 bg-slate-950 rounded border border-slate-600">
              <div className="absolute left-0 top-0 w-20 h-full bg-slate-800 border-r border-slate-700 p-2 text-xs text-slate-400 shadow-lg">Float</div>
              <div className="ml-20 p-2 text-xs text-slate-400">Content overlay</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">\n  <div className="absolute left-0 top-0 w-20 bg-slate-800">Sidebar</div>\n  <div className="ml-20 p-2">Content</div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Expandable Sections</label>
            <div className="space-y-1 h-32 bg-slate-950 rounded border border-slate-600 p-2 overflow-auto">
              <div className="bg-slate-700 p-2 rounded text-xs text-slate-300 font-medium">Section 1 ?</div>
              <div className="text-xs text-slate-500 pl-2">Item 1.1</div>
              <div className="text-xs text-slate-500 pl-2">Item 1.2</div>
              <div className="bg-slate-800 p-2 rounded text-xs text-slate-400 font-medium">Section 2 ?</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-1">\n  <div className="bg-slate-700 p-2 rounded">Section ?</div>\n  <div className="text-xs pl-2">Item</div>\n  <div className="bg-slate-800 p-2">Section ?</div>\n</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;


